import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: {
    invoices: {
      invoices: [],
      pagination: {
        page_number: 1,
        num_pages: 1,
        page_size: 10,
        total_count: 10,
      },
    },
    filters: {
      dateFrom: null,
      dateTo: null,
      status: null,
    },
  },
  mutations,
  actions,
  getters,
};
